import React, { useState, useRef } from "react";
import AboutBannerImage1 from "../../src/assets/images/aboutbanner1.png";
import AboutBannerImage2 from "../../src/assets/images/Learning.jpg.jpeg";
import AboutBannerImage3 from "../../src/assets/images/dna1.png";
import CustomLine from "./CustomLine";
import AboutImage1 from "../../src/assets/images/image_40.png";
import AboutImage2 from "../../src/assets/images/image_41.png";
import AppoinmentModal from "./AppoinmnetModal";
import { FaCheck } from "react-icons/fa";
import { FiVideo } from "react-icons/fi";
import { HiOutlineDesktopComputer, HiOutlineBookOpen } from "react-icons/hi";
import { BookOpenCheck, LaptopMinimalCheck, TvMinimalPlay, ChartColumn } from "lucide-react";

const CourseBannerAbout = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="custom-science pt-80 bg-[#f2f0ed]">
            <div className="xl-screen-padding flex gap-10 flex-col md:flex-row w-full bg-white">
                {/* Left Section - Image */}
                <div className="custom-padding w-full md:w-1/2 flex items-center justify-center py-12">
                    <div className="relative rounded-lg overflow-hidden w-full max-w-2xl mx-auto">
                        <div className="relative w-full" style={{ paddingBottom: '75%' }}> {/* 4:3 Aspect Ratio */}
                            <img
                                src={AboutBannerImage2}
                                alt="Personalized roadmap"
                                className="absolute inset-0 w-full h-full object-cover rounded-lg"
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>
                {/* Right Section - Content */}
                <div className="w-full md:w-1/2 flex flex-col justify-center aboutmain py-8 sm:py-12 px-4 sm:px-6 md:pr-8">
                    <p className="text-[#6BCB3D] text-sm font-semibold font-lato tracking-widest mb-3 uppercase">
                        About Nutrillion Academy
                    </p>
                    <h2 className="text-lg sm:text-xl md:text-xl lg:text-4xl font-semibold text-[#2f3a40] leading-tight mb-6 font-merriweather">
                        Learning Ecosystem
                        <br />
                        for Curious Minds
                    </h2>
                    <p className="text-gray-500 mb-10 text-[15px] leading-relaxed max-w-lg font-lato">
                        The academy welcomes a diverse cohort of learners to healthcare professionals, biotechnology and life-sciences enthusiasts, sports nutrition aspirants, and individuals keen to explore emerging domains such as nutrigenomics, gut microbiome science, and precision-based dietary interventions.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
                        <div className="flex items-start gap-3 sm:gap-4">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <BookOpenCheck className="text-green-600 text-base sm:text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato text-sm sm:text-base">
                                    Evidence-Based Curriculum
                                </h4>
                                <p className="text-xs sm:text-sm text-gray-500 font-lato">
                                    Master nutrition through research-backed, industry-relevant content.
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3 sm:gap-4">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <LaptopMinimalCheck className="text-gray-600 text-base sm:text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato text-sm sm:text-base">
                                    Flexible Learning
                                </h4>
                                <p className="text-xs sm:text-sm text-gray-500 font-lato">
                                    Learn at your own pace, from any device, whenever it suits you.
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3 sm:gap-4">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <TvMinimalPlay className="text-gray-600 text-base sm:text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato text-sm sm:text-base">
                                    Interactive Learning Experience
                                </h4>
                                <p className="text-xs sm:text-sm text-gray-500 font-lato">
                                    Engage with videos, quizzes, case studies, and curated learning resources.
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3 sm:gap-4">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <ChartColumn className="text-green-600 text-base sm:text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato text-sm sm:text-base">
                                    Track Your Progress
                                </h4>
                                <p className="text-xs sm:text-sm text-gray-500 font-lato">
                                    Monitor your course completion, assessments, and certifications from one dashboard.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative">
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>
                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>
        </div>
    );
};

export default CourseBannerAbout;